import React from "react";
import {Box, Stack} from "@mui/material";

const FormControlsLayout = ({children}) => {
    return <Box sx={{pt: 2}}>
        <Stack spacing={2} direction="row">
            {children}
        </Stack>
    </Box>
}

export default FormControlsLayout